const PlanEventQueryKey = {
  PLANNING_EVENT: 'PLANNING_EVENT',
  PLANNING: 'PLANNING',
  EVENT: 'EVENT',
};

export default PlanEventQueryKey;
